import { FunctionComponent } from 'react';
import Parser from 'html-react-parser';

import l from '../../../../lang';
import { SwitchWithLabel } from '../../../common/switch-with-label';
import ButtonLink from '../../../common/button-link';
import { openNewTabAndFocus } from '../../../../utils';
import { Urls } from '../../../../config/urls';

interface ShopifyTransparentInstalledProps {
  testMode: boolean;
  disabled?: boolean;
  onTestModeChange?: (testMode: boolean) => void;
}

export const ShopifyTransparentInstalled: FunctionComponent<ShopifyTransparentInstalledProps> = ({
  testMode,
  disabled = false,
  onTestModeChange,
}) => (
  <>
    <div className="add-to-shopify__desc">
      <p>{Parser(l('paymentIntegration.shopify.desc.installed.transparent'))}</p>
    </div>
    <div className="add-to-shopify__switch">
      <SwitchWithLabel
        onChange={onTestModeChange && onTestModeChange}
        disabled={disabled}
        label={l('paymentIntegration.shopify.environment.testing')}
        checked={testMode}
      />
    </div>
    <div className="add-to-shopify__desc">
      <p>
        <span>{Parser(l('paymentIntegration.shopify.test.docs.text.installed.transparent'))} </span>
        <ButtonLink
          text={l('paymentIntegration.shopify.test.docs.installed.transparent')}
          onClick={() => openNewTabAndFocus(Urls.docs.shopifyTransparentIntegration)}
        />
      </p>
      <div>{l('paymentIntegration.shopify.test.reminder.installed.transparent')}</div>
    </div>
  </>
);
